





















































































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import isEqual from 'lodash.isequal';
import debounce from 'lodash.debounce';
import { FilterDTO, FilterDTOTypeEnum } from '@/api';
import IconTimes from '@/assets/icons/times.svg';
import IconSearch from '@/assets/icons/search.svg';
import IconArrowLeft from '@/assets/icons/arrow-left.svg';
import services from '@/services';

type Filter = Pick<FilterDTO, 'type' | 'id' | 'name' | 'gender' | 'colorHex'> & {parent: Filter | null, children?: Filter[], leaf?: boolean}

@Component({
  name: 'catalog-filter',
  components: { IconTimes, IconSearch, IconArrowLeft },
})
export default class CatalogFilter extends Vue {
  @Prop(Boolean) open!: boolean

  @Prop() currentFilters!: FilterDTO[]

  searchString: string = ''

  filters: FilterDTO[] = []

  searchResults: FilterDTO[] = []

  filterTypeOptions: FilterDTO[] = []

  filterTypeOptionsLoading: boolean = false

  filterTypes: { [key: string]: string; } | null = null;

  filterTypeSelected: FilterDTOTypeEnum | null = null

  selectedChild: Filter | null = null;

  async created() {
    const { data } = await services.catalogService().catalogEndpointGetFilterTypeNames();
    this.filterTypes = data;
  }

  get visiblyFilters() {
    if (!this.filterTypeSelected) {
      return [];
    }
    if (this.selectedChild && this.selectedChild.children?.length) {
      return this.selectedChild.children || [];
    }
    return this.options;
  }

  get options() {
    const mapper = (filter: Filter, parent: Filter | null = null): Filter => {
      const mappedChildren = filter.children?.length
        ? filter.children.map(child => mapper(child, filter))
        : [];

      const children = filter.children ? [{ ...filter, name: `Все в категории "${filter.name}"`, leaf: true }, ...mappedChildren] : undefined;

      return {
        ...filter,
        parent,
        children,
        leaf: !children?.length,
      };
    };
    // const hasChild = (filter: FilterDTO) => filter.children?.map((child): FilterDTO => ({
    //   ...child,
    //   children: child.children ?
    // [{ ...child, name: `Все в категории "${child.name}"` }, ...hasChild(child)] : undefined,
    // })) || [];

    return this.filterTypeOptions.map(item => mapper(item as Filter));
  }

  @Watch('searchString')
  async onSearchChange(value: string) {
    this.debouncedGetSearchParameters(value);
  }

  @Watch('filterTypeSelected')
  async onFilterTypeChange(value: FilterDTOTypeEnum) {
    if (!value) {
      return;
    }
    this.filterTypeOptionsLoading = true;
    try {
      const { data } = await services.catalogService().catalogEndpointGetFilterNames(value);
      this.filterTypeOptions = data;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.filterTypeOptionsLoading = false;
    }
  }

  selectFilterType(filter: FilterDTOTypeEnum) {
    this.selectedChild = null;
    this.filterTypeSelected = filter;
  }

  resetFilterType() {
    this.filterTypeSelected = null;
  }

  selectChild(filter: Filter | null) {
    this.selectedChild = filter;
  }

  levelUpChild() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { options, selectedChild } = this;
    if (selectedChild && selectedChild.parent) {
      this.selectChild(selectedChild.parent);
    } else {
      this.selectChild(null);
    }
  }

  async getSearchParameters(query: string) {
    if (query.length > 2) {
      const { data } = await services.catalogService().catalogEndpointGetSearchParameters(query);
      this.searchResults = data;
    } else {
      this.searchResults = [];
    }
  }

  debouncedGetSearchParameters = debounce(this.getSearchParameters, 500);

  formatSearchResultName(resultName: string): string {
    return resultName.replace(
      new RegExp(this.searchString, 'gi'), (match: string) => `<b>${match}</b>`,
    );
  }

  addFilter(item: FilterDTO): void {
    if (!this.filters.find(filter => isEqual(filter, item))) this.filters.push(item);
  }

  removeFilter(item: FilterDTO): void {
    this.filters = this.filters.filter(filter => !isEqual(filter, item));
  }

  clearFilters(): void {
    this.filters = [];
  }

  submit(): void {
    this.$emit('submit', this.filters);
  }

  refreshState() {
    this.filters = Array.from(this.currentFilters);
    this.searchString = '';
    this.filterTypeSelected = null;
  }
}
